(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozokart-gifting"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-ozg-ready')) return;
    root.setAttribute('data-ozg-ready', '1');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vidOf = function (s) {
      var vs = s.querySelectorAll('video');
      for (var k = 0; k < vs.length; k++) { if (getComputedStyle(vs[k]).display !== 'none') return vs[k]; }
      return null;
    };
    var slider = root.querySelector('.ozg-slider');
    if (slider) {
      var track = slider.querySelector('.ozg-track');
      var slides = track.querySelectorAll('.ozg-slide');
      var dots = slider.querySelectorAll('.ozg-dot');
      var prev = slider.querySelector('.ozg-arrow-prev');
      var next = slider.querySelector('.ozg-arrow-next');
      var n = slides.length, idx = 0, timer = null, paused = false, DELAY = 6000;
      var render = function () {
        var step = slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(slides[0]).marginRight) || 0);
        track.style.transform = 'translateX(' + (-idx * step) + 'px)';
        slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
        dots.forEach(function (d, i) { if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        slides.forEach(function (s, i) {
          var act = vidOf(s);
          s.querySelectorAll('video').forEach(function (v) { if (i !== idx || v !== act) v.pause(); });
          if (act && i === idx) { var play = act.play(); if (play && play.catch) play.catch(function () {}); }
        });
      };
      var go = function (i) { idx = (i + n) % n; render(); };
      var stop = function () { if (timer) clearInterval(timer); timer = null; };
      var start = function () { stop(); if (reduce || n < 2) return; timer = setInterval(function () { if (!paused) go(idx + 1); }, DELAY); };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-i')); start(); }); });
      if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
      if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
      slider.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(idx + 1); start(); } else if (e.key === 'ArrowLeft') { go(idx - 1); start(); } });
      slider.addEventListener('mouseenter', function () { paused = true; }); slider.addEventListener('mouseleave', function () { paused = false; });
      slider.addEventListener('focusin', function () { paused = true; }); slider.addEventListener('focusout', function () { paused = false; });
      var sx = null; slider.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) { go(dx < 0 ? idx + 1 : idx - 1); start(); } }, { passive: true });
      render(); start();
      window.addEventListener('resize', function () { render(); });
    }
    root.querySelectorAll('[data-video-toggle]').forEach(function (button) {
      var slide = button.closest('.ozg-slide'); if (!slide) return;
      var videos = slide.querySelectorAll('video'); if (!videos.length) return;
      var mutedIcon = button.querySelector('.ozg-icon-muted'), unmutedIcon = button.querySelector('.ozg-icon-unmuted');
      var sync = function () {
        var v = vidOf(slide) || videos[0];
        var isMuted = v.muted || v.volume === 0;
        if (mutedIcon) mutedIcon.toggleAttribute('hidden', !isMuted);
        if (unmutedIcon) unmutedIcon.toggleAttribute('hidden', isMuted);
        button.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
        button.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
      };
      button.addEventListener('click', function () {
        var cur = vidOf(slide) || videos[0];
        var m = !cur.muted;
        videos.forEach(function (v) { v.muted = m; if (!m && v.volume === 0) v.volume = 1; });
        sync();
      });
      videos.forEach(function (v) { v.addEventListener('volumechange', sync); });
      window.addEventListener('resize', sync);
      sync();
    });
    var zohoFrames = [];
    var mountZoho = function (box) {
      var src = box.getAttribute('data-src');
      if (!src || box.querySelector('iframe')) return;
      var add = function (u, k, v) { return u + (u.indexOf('?') > 0 ? '&' : '?') + k + '=' + v; };
      try {
        if (typeof ZFAdvLead != 'undefined' && typeof zfutm_zfAdvLead != 'undefined') {
          for (var i = 0; i < ZFAdvLead.utmPNameArr.length; i++) {
            var nm = ZFAdvLead.utmPNameArr[i], key = (ZFAdvLead.isSameDomian && (ZFAdvLead.utmcustPNameArr.indexOf(nm) == -1)) ? 'zf_' + nm : nm;
            var val = zfutm_zfAdvLead.zfautm_gC_enc(nm);
            if (typeof val !== 'undefined' && val != '') src = add(src, key, val);
          }
        }
        if (typeof ZFLead !== 'undefined' && typeof zfutm_zfLead !== 'undefined') {
          for (var j = 0; j < ZFLead.utmPNameArr.length; j++) {
            var nm2 = ZFLead.utmPNameArr[j], val2 = zfutm_zfLead.zfutm_gC_enc(nm2);
            if (typeof val2 !== 'undefined' && val2 != '') src = add(src, nm2, val2);
          }
        }
        if (!/[?&]referrername=/.test(src)) {
          var rfr = window.location.href;
          try { rfr = window.self !== window.top ? window.top.location.href : rfr; } catch (e) {}
          if (rfr) {
            if (rfr.length > 1800) { var qi = rfr.indexOf('?'); if (qi > -1) rfr = rfr.substring(0, qi); if (rfr.length > 1800) rfr = rfr.substring(0, 1800); }
            src = add(src, 'referrername', encodeURIComponent(rfr));
          }
        }
      } catch (e) {}
      var f = document.createElement('iframe');
      f.src = src; f.title = 'Request a Quote'; f.setAttribute('aria-label', 'Request a Quote');
      var thanks = box.getAttribute('data-thanks'), loads = 0, sent = false, maxH = 0, t0 = Date.now();
      var dbg = /[?&]ozgdebug/.test(window.location.search);
      var log = function () { if (dbg && window.console) console.log.apply(console, ['[ozg]'].concat([].slice.call(arguments))); };
      var toThanks = function (why) {
        log('submitted ->', why, '| going to:', thanks);
        if (!thanks || sent) return;
        if (window.Shopify && window.Shopify.designMode) return;
        sent = true;
        window.location.href = thanks;
      };
      f.addEventListener('load', function () {
        loads++; log('iframe load #' + loads);
        if (loads < 2) return;
        if (Date.now() - t0 < 3000) { log('ignored early reload'); return; }
        toThanks('iframe navigated (Zoho redirect / reload)');
      });
      box.appendChild(f); zohoFrames.push(f);
      window.addEventListener('message', function (ev) {
        var d = ev.data;
        if (!d || d.constructor !== String) return;
        var p = d.split('|');
        if (p.length !== 2 && p.length !== 3) return;
        var known = zohoFrames.some(function (fr) { return fr.contentWindow === ev.source; });
        if (known && ev.source !== f.contentWindow) return;
        if (f.src.indexOf('formperma') < 0 || f.src.indexOf(p[0]) < 0) return;
        var hn = parseInt(p[1], 10) || 0;
        log('message', d);
        if (hn > 0) {
          if (hn > maxH) maxH = hn;
          else if ((p.length === 3 && hn < maxH * 0.9) || hn < maxH * 0.5) toThanks('form got shorter: ' + maxH + ' -> ' + hn);
        }
        var h = (parseInt(p[1], 10) + 15) + 'px';
        var scroll = p.length === 3;
        if (scroll) f.scrollIntoView();
        if (f.style.height !== h) { if (scroll) setTimeout(function () { f.style.height = h; }, 500); else f.style.height = h; }
      }, false);
    };
    root.querySelectorAll('[data-ozg-zoho]').forEach(mountZoho);
    var dlg = root.querySelector('[data-ozg-dialog]');
    if (dlg && typeof dlg.showModal === 'function') {
      var lazyBox = dlg.querySelector('[data-ozg-zoho-lazy]');
      var openDlg = function () {
        if (lazyBox && !lazyBox.querySelector('iframe')) mountZoho(lazyBox);
        if (!dlg.open) dlg.showModal();
        document.documentElement.classList.add('ozg-lock');
      };
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('ozg-lock'); });
      dlg.addEventListener('click', function (e) {
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
      });
      var closeBtn = dlg.querySelector('[data-ozg-dialog-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
      root.querySelectorAll('[data-ozg-enquire]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); openDlg(); });
      });
    }
    var productTrack = root.querySelector('[data-product-track]');
    if (productTrack) {
      var cards = productTrack.querySelectorAll('.ozg-card'), pprev=root.querySelector('[data-product-prev]'), pnext=root.querySelector('[data-product-next]'), pidx=0;
      var visible = function(){return window.matchMedia('(max-width: 767px)').matches ? 2 : 4;};
      var update = function(){var vis=visible(), max=Math.max(0,cards.length-vis);pidx=Math.min(pidx,max);var card=cards[0];if(card){var style=window.getComputedStyle(productTrack),gap=parseFloat(style.columnGap||style.gap)||0;productTrack.style.transform='translateX('+(-pidx*(card.getBoundingClientRect().width+gap))+'px)';}if(pprev){pprev.disabled=pidx<=0;pprev.hidden=cards.length<=vis;}if(pnext){pnext.disabled=pidx>=max;pnext.hidden=cards.length<=vis;}};
      if(pprev) pprev.addEventListener('click',function(){pidx=Math.max(0,pidx-visible());update();}); if(pnext) pnext.addEventListener('click',function(){pidx=Math.min(Math.max(0,cards.length-visible()),pidx+visible());update();});
      window.addEventListener('resize',update); update();
    }
    root.addEventListener('click', function (e) { var a=e.target.closest ? e.target.closest('a[href^="#"]') : null; if(!a)return;var id=a.getAttribute('href').slice(1);if(!id)return;var t=document.getElementById(id);if(!t||!root.contains(t))return;e.preventDefault();t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});if(id.indexOf('ozg-quote-')===0){var f=t.querySelector('input,select,textarea');if(f)setTimeout(function(){try{f.focus({preventScroll:true});}catch(_){f.focus();}},reduce?0:600);}});
  }
  function initAll(scope){(scope||document).querySelectorAll('.ozg').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll();});else initAll();
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
